import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import RenderVolumeCard from './RenderVolumeCard';
import SettingsCard from "./SettingsCard";

export default function MainGrid(props) {
  const {auth, page} = props

  if (page === 'Profile') {
    return (
        <Box sx={{width: '100%', maxWidth: '100%'}}>
          <SettingsCard auth={auth}/>
        </Box>
    );
  }
  return (
      <Box sx={{width: '100%', maxWidth: '100%'}}>
        <Grid
            container
            spacing={2}
            columns={12}
          sx={{mb: 0}}
        >
          {/* <Grid size={{xs: 12}}>
            <UploadFolderCard auth={auth} storage={storage}/>
          </Grid> */}
          <Grid size={{sm: 12}}>
            <RenderVolumeCard auth={auth}/>
          </Grid>
        </Grid>
      </Box>
  );
}